import { gql } from '@apollo/client';
import { RECURRENCE_FRAGMENT } from '../../../../common/recurrence/recurrence-model.gql';

// Lighter fragment for MyShifts - excludes publishedRosters since roster data
// is already provided per-date in upcomingRoster.publishedRoster
export const MyShiftsActivityFragment = gql`
  fragment MyShiftsActivity on VOLUNTEER_ActivityType {
    activityId
    isActive
    isEnrollable
    isRestrictedActivity
    name
    startTime
    endTime
    startDate
    endDate
    isSuspended
    isHidden
    hasOpenRoster
    priority
    allowCICO
    effectiveAddressRevealBeforeDays
    effectiveAddressHideAfterDays
    program {
      programId
      name
      allowCICO
    }
    sessions(includeOneOff: true) {
      sessionId
      name
      description
      startTime
      endTime
      isFlexible
      isOneOff
      activityDate
      currentFlexibleInstances {
        flexibleSessionInstanceId
        sessionDate
        startTime
        endTime
        name
      }
      activityLocation {
        placesAddress {
          placesId
          description
          formatted
          latLong {
            lat
            long
          }
        }
      }
    }
    activityTags {
      activityTagId
      name
      description
    }
    activityLocation {
      activityLocationId
      placesAddress {
        placesId
        description
        formatted
        latLong {
          lat
          long
        }
      }
    }
    activityRemoteLocation {
      activityRemoteLocationId
      details
    }
    maxVolunteers
    cancelledActivities(startDate: $startDate, endDate: $endDate) {
      activityDate
    }
    nextX(x: 1)
    occurrencesBetween(from: $startDate, until: $endDate)
    ... on VOLUNTEER_RecurringActivityType {
      schedule {
        recurrences {
          ...Recurrence
        }
      }
    }
    rosterTemplates {
      rosterDate
      placesAddress {
        formatted
      }
    }
  }
  ${RECURRENCE_FRAGMENT}
`;

export const ActivityTimelineItemFragments = gql`
  fragment ActivityTimelineItem on VOLUNTEER_ActivityType {
    activityId
    isActive
    isEnrollable
    isRestrictedActivity
    name
    startTime
    endTime
    startDate
    endDate
    isSuspended
    isHidden
    hasOpenRoster
    priority
    allowCICO
    effectiveAddressRevealBeforeDays
    effectiveAddressHideAfterDays
    program {
      programId
      name
      allowCICO
    }
    sessions(includeOneOff: true) {
      sessionId
      name
      description
      startTime
      endTime
      isFlexible
      isOneOff
      activityDate
      currentFlexibleInstances {
        flexibleSessionInstanceId
        sessionDate
        startTime
        endTime
        name
      }
      activityLocation {
        placesAddress {
          placesId
          description
          formatted
          latLong {
            lat
            long
          }
        }
      }
    }
    activityTags {
      activityTagId
      name
      description
    }
    activityLocation {
      activityLocationId
      placesAddress {
        placesId
        description
        formatted
        latLong {
          lat
          long
        }
      }
    }
    activityRemoteLocation {
      activityRemoteLocationId
      details
    }
    publishedRosters(startDate: $startDate, endDate: $endDate) {
      activityDate
      rosterings {
        publishedRosteringId
        volunteer {
          volunteerId
        }
        dateRemoved
      }
    }
    maxVolunteers
    cancelledActivities(startDate: $startDate, endDate: $endDate) {
      activityDate
    }
    nextX(x: 1)
    occurrencesBetween(from: $startDate, until: $endDate)
    ... on VOLUNTEER_RecurringActivityType {
      schedule {
        recurrences {
          ...Recurrence
        }
      }
    }
    rosterTemplates {
      rosterDate
      placesAddress {
        formatted
      }
    }
  }
  ${RECURRENCE_FRAGMENT}
`;
